import { createStore } from "vuex";
import music from "./music";

export default createStore({
  state: {
  },
  mutations: {},
  actions: {},
  modules: {
    music,
  },
});
